<template>
    <div class="confirmation-container-wrapper">
        <div class="updateGuide" v-if="updateGuide"></div>
        <div class="__flex-con">
            <div class="confirmation-header">
                <!-- <div class="title" v-if="activeTab == '2'">{{ $t('confirmation_dashboard_title') }}</div> -->
                <!-- <div class="detail-header" v-else> -->
                <div class="detail-header">
                    <div class="title">
                        {{ $t('confirmation_title') }}
                    </div>

                    <div class="guide-tip">
                        <svg-icon icon-name="icon-guidance" :size="28" icon-color="#00b8f5"></svg-icon>
                    </div>
                    <GuidanceTooltip
                        v-if="false"
                        :content="confirmationTip"
                        :jumpLink="$t(`confirmation.details_list.confirmationTipLink_${getUser.userType}`)"
                        :size="20"
                        :iconSize="15"
                        :placement="'right'"
                    >
                        <!--<img slot="icon" src="@/assets/img/icon-tips.svg" alt="">-->
                    </GuidanceTooltip>
                </div>
                
                <ul class="ul-container">
                    <!--<GuidanceTooltip
                        :content="$t('confirmation.details_list.confirmationTip_2')"
                        backgroundColor="none"
                        placement="left">
                        <i slot="icon" class="el-icon-warning" style="color:#fd349c;"></i>
                        &lt;!&ndash;<img slot="icon" src="@/assets/img/camera.svg" alt="">&ndash;&gt;
                    </GuidanceTooltip>-->
                    <div :class="updateGuide && updateGuideStep === 5 ? 'updateGuideIcon' : ''">
                        <li class="active" @click="openDashbard">
                            {{ $t('confirmation.homepage.tab.dashboard') }}
                            <div :class="['new-tag', `new_${$i18n.locale}`]"></div>
                        </li>

                        <div class="updateGuideTip" v-if="updateGuide && updateGuideStep === 5">
                            <div class="margin-bottom-10">5/5</div>
                            <div class="margin-bottom-10">{{ $t('confirmation_bubble_5') }}</div>
                            <el-button @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
                        </div>
                    </div>
                </ul>
            </div>
            <div @click="show2 = !show2" class="__tips mb-10">
                <div style="display: flex; align-items: center;">
                    <div v-html="confirmationTip" class="guide-content-container"></div>
                    <i :class="[show2 ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
                </div>
                <transition name="el-zoom-in-top">
                    <div v-show="show2">
                        <div v-html="subConfirmationTip"></div>
                        <div v-html="$t('confirmation.details_list.dianzi')"></div>
                    </div>
                </transition>
            </div>
            
            <div
                :class="[
                    'confirmation-content',
                    screenWidth < 1920 ? 'small' : screenWidth == 1920 ? 'medium' : 'large',
                    $i18n.locale === 'zh' ? 'zh-cls' : 'en-cls'
                ]"
            >
                <NewComments messageType="11" :siteId="siteId"></NewComments>
                <DetailList
                    ref="detailList"
                    class="content1 content-with-comments"
                    :updateGuide="updateGuide"
                    :updateGuideStep="updateGuideStep"
                    :nextClick="nextClick"
                />
                <!-- <dashboard class="content2" v-if="activeTab == '2'"/> -->
            </div>
        </div>

        <el-drawer
            :visible.sync="showDashboard"
            direction="rtl"
            custom-class="dashboard-drawer"
            append-to-body
            destroy-on-close
            :size="collapseDashboard ? '30%' : '80%'"
            :modal="false"
        >
            <template #title>
                <div class="confirmation-header-title">{{ $t('confirmation_dashboard_title') }}</div>
            </template>
            <div class="content2">
                <dashboard />
                <!-- <div class="collapse-btn" @click="switchCollapse">{{ collapseDashboard ? $t('unfold') : $t('fold')}}</div> -->
            </div>
        </el-drawer>
    </div>
</template>

<script>
import Dashboard from './Components/Dashboard'
import DetailList from './Components/DetailList.vue'
import { mapGetters } from 'vuex'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import { loading } from '@/utils'
import API from '@/api'
import SvgIcon from '@/components/svgIcon/index'
import NewComments from '@/components/common/NewComments.vue'
export default {
    name: 'confirmation',
    components: {
        Dashboard,
        DetailList,
        GuidanceTooltip,
        SvgIcon,
        NewComments
    },
    data() {
        return {
            show2: false,
            screenWidth: document.body.clientWidth,
            videoTipImg: require('@/assets/img/kpicon-video.svg'),
            tabList: [
                {
                    name: this.$t('confirmation.homepage.tab.details_list'),
                    value: '1'
                },
                {
                    name: this.$t('confirmation.homepage.tab.dashboard'),
                    value: '2'
                }
            ],
            activeTab: '1',
            showDashboard: false,
            collapseDashboard: false,
            showConfirmationReplyStatus: true,
            updateGuide: false,
            updateGuideStep: 1
        }
    },
    async created() {
        const __ = this.$route.query
        if (__) {
            if (__.siteId) {
                this.$store.commit('common/setSite', {
                    siteId: __.siteId,
                })
                const { code,data } = await API.businessHome.querySiteInfoBySiteId({
                    siteId: __.siteId
                })
                if (code === '1') {
                    this.$store.commit('common/setSite', {
                        ...data,
                        siteId: __.siteId,
                    })
                }
                
            }
            if (__.siteClassification) {
                sessionStorage.setItem('siteClassification', __.siteClassification)
            }
        }
    },
    async mounted() {
        if (localStorage.getItem('showConfirmationReplyChanged')) {
            localStorage.removeItem('showConfirmationReplyChanged')
            window.location.reload()
            return
        }
        // await this.getTileGeneral()
        window.onresize = () => {
            this.$refs['detailList'].changeGuideTitleHeight()
            return (this.screenWidth = document.body.clientWidth)
        }
        this.getBehavior()

        //默认展示dashboard页面
        if (this.$route.query.openDashboard == '1'){
            this.openDashbard();
        }

    },
    methods: {
        switchCollapse() {
            this.collapseDashboard = !this.collapseDashboard
        },
        changeTab(val) {
            if (val === this.activeTab) return
            this.activeTab = val
        },
        openDashbard() {
            this.showDashboard = true
            this.collapseDashboard = false
        },
        async getTileGeneral() {
            const _loading = loading()
            _loading.load()
            return API.general
                .siteTilesGeneral({ siteId: this.getSite.siteId })
                .then((res) => {
                    if (res.code == '1') {
                        this.showConfirmationReplyStatus = res.data.showConfirmationReplyStatus
                    }
                })
                .finally(() => {
                    _loading.close()
                })
        },
        nextClick() {
            this.updateGuideStep++
        },
        gotItClick() {
            let param = {
                confirmationNoticeReadFlag: 1
            }
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                    this.updateGuideStep = 0
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.updateGuide = res.data.confirmationNoticeReadFlag === 0
                    this.updateGuideStep = 1
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite'
        }),
        confirmationTip() {
            if (this.getUser.userType == '1') {
                return this.$t('confirmation.details_list.confirmationTip_kp')
            } else {
                return this.$t('confirmation.details_list.confirmationTip_client')
            }
        },
        subConfirmationTip() {
            if (this.getUser.userType == '1') {
                return this.$t('confirmation.details_list.zhizhi_kp')
            } else {
                return this.$t('confirmation.details_list.zhizhi_client')
            }
        },
        siteId() {
            return this.getSite.siteId
        },
    }
}
</script>

<style scoped>
.guide-content-container{
    display: inline-block;
    /* font-size: 12px; */
    /* margin-right: 40px; */
}
.guide-tip{
    background: #00b8f5;
    border-radius: 5px;
    width: 32px;
    height: 32px;
    text-align: center;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:5px;
}
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
}
.confirmation-container-wrapper {
    color: #444;
    height: 100%;
    background: #eff1f5;
    padding: 15px;
    /* overflow: auto; */
}

.confirmation-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
}

.confirmation-header-title {
    height: 39px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}
.confirmation-header .detail-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}
.confirmation-header .detail-header .title {
    font-size: 25px;
    margin-right: 10px;
}
.confirmation-header .confirmation-tip,
.videotip {
    display: flex;
    align-items: center;
    font-size: 12px;
}
.confirmation-header .confirmation-tip .icon-tip {
    font-size: 36px;
    color: #00338d;
    margin-right: 10px;
}

.videotip .video-tip-img {
    width: 36px;
    height: 36px;
    margin-right: 10px;
}

.videotip .video-tip-text {
    font-size: 12px;
    line-height: 18px;
    color: #333333;
}
.confirmation-header ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    /* border: 1PX solid #DCDFE6; */
    border-radius: 5px;
    font-size: 14px;
    /* background: #fff; */
    color: #333333;
    flex-shrink: 0;
    flex-direction: row;
    align-items: center;
}

.confirmation-header ul li {
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 5px;
    margin-left: 10px;
}

.confirmation-header ul .updateGuideIcon li {
    margin-left: 0;
}

/* .confirmation-header ul li:nth-child(1) {
        border-radius: 5px 0 0 5px;
    }

    .confirmation-header ul li:nth-child(2) {
        border-radius: 0 5px 5px 0;
    } */

.confirmation-header ul li.active {
    font-weight: bold;
    background-color: #3879eb;
    color: #fff;
    position: relative;
}

.new-tag {
    display: inline-block;
    position: absolute;
    height: 32px;
    z-index: 6;
}
/* .new_zh {
    background: url('~@/assets/img/client_new_cn.png') no-repeat;
    background-size: contain;
    width: 64px;
    left: -50px;
    top: -14px;
} */
/* .new_en {
    background: url('~@/assets/img/client_new_en.png') no-repeat;
    background-size: contain;
    width: 64px;
    left: -50px;
    top: -14px;
} */
.confirmation-content {
    /* height: calc(100% - 80px); */
}
.confirmation-content .content1 {
    height: 100%;
}
/* .confirmation-content.small.en-cls .content1{
        height: 61vh;
    }
    .confirmation-content.small.zh-cls .content1{
        height: 66vh;
    }
    .confirmation-content.medium.en-cls .content1{
        height: 71vh;
    }
    .confirmation-content.medium.zh-cls .content1{
        height: 72vh;
    }
    .confirmation-content.large.en-cls .content1{
        height: 73vh;
    }
    .confirmation-content.large.zh-cls .content1{
        height: 74vh;
    } */
.confirmation-content .content2 {
    height: calc(100% - 39px);
    position: relative;
}

::v-deep .content2 .collapse-btn {
    width: 40px;
    height: 40px;
    background-color: #7a2f84;
    color: white;
    position: absolute;
    top: calc(50% - 20px);
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
}
::v-deep .dashboard-drawer {
    padding: 0 20px;
    transition: width linear 0.3s;
}
::v-deep .el-collapse {
    border-top: none;
}
::v-deep .el-collapse-item__header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.updateGuideIcon {
    height: fit-content;
    width: fit-content;
    z-index: 101;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
    position: relative;
}
.updateGuideIcon .updateGuideTip {
    z-index: 101;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    right: 0;
    top: calc(45px + 10px);
    width: 240px;
    border-radius: 10px;
    line-height: normal;
    font-size: 14px;
    line-height: normal;
}
.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}



.confirmation-container-wrapper .__flex-con {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.confirmation-header {
    height: 40px;
}

.confirmation-container-wrapper .__tips {
}

.confirmation-content {
    flex: 1;
    position: relative;
}
</style>
